const Portals = () => {
  return (
    <>
      <div id="popper-portal" />
      <div id="modal-portal" />
    </>
  )
}

export default Portals
